import nanostyled from 'nanostyled';

export const Container = nanostyled('div', {
  base: 'h-screen sm:h-3/4vh md:h-2/3vh pointer-events-none',
});
